import { useEffect, useState } from "react";
import { GroupSyncActions } from "authentication/stores/directoryServices/GroupSyncStore";
import { OKTA_TYPE_KEY } from "authentication/components/oidc/constants";
const prepareFormValues = (backendGroupSync, type) => {
  const { selectionType, selection, defaultRoles, config } = backendGroupSync;
  const oktaApiToken = config == null ? void 0 : config.oktaApiToken;
  const hasOktaApiToken = typeof oktaApiToken !== "undefined" && oktaApiToken !== null && (oktaApiToken.is_set || oktaApiToken.keep_value || oktaApiToken.set_value);
  return {
    teamDefaultRoles: defaultRoles.join(),
    teamSelectionType: selectionType,
    ...type === OKTA_TYPE_KEY ? { oktaApiToken: hasOktaApiToken ? { is_set: true } : void 0 } : { groupsClaim: config.groupsClaim },
    teamSelection: selection,
    synchronizeGroups: true
  };
};
const useInitialGroupSyncValues = (backendId, type, initialFormValues) => {
  const [backendGroupSync, setBackendGroupSync] = useState();
  const [finishedLoading, setFinishedLoading] = useState(false);
  useEffect(() => {
    if (backendId) {
      GroupSyncActions.load(backendId).then((result) => {
        if (result && result.backend) {
          setBackendGroupSync(result.backend);
        }
        setFinishedLoading(true);
      }).catch(() => {
        setFinishedLoading(true);
        setBackendGroupSync(void 0);
      });
    }
  }, [backendId]);
  return {
    finishedLoading: backendId ? finishedLoading : true,
    formValues: backendGroupSync ? prepareFormValues(backendGroupSync, type) : initialFormValues
  };
};
export default useInitialGroupSyncValues;
